/* eslint-disable @typescript-eslint/no-var-requires */
import isEmpty from 'lodash.isempty';

export default isEmpty;
